module.exports = __webpack_public_path__ + "img/img_infmember.16351eb8.svg";